<template>
  <b-modal
    v-model="showModal"
    ref="modalSelectVoucher"
    centered
    @hidden="hide"
    :hide-footer="hideFooter"
  >
    <template #modal-header>คูปอง</template>
    <HeaderPanel
      title="คูปอง"
      :filter="filter"
      placeholder="Search Code"
      :hasDropdown="false"
      :hasFilter="false"
      :hasSearch="false"
      @search="handleSearch"
    />

    <div class="body">
      <b-table
        striped
        hover
        responsive
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
        class="mt-2"
      >
        <template v-slot:cell(endDate)="data">
          <div>
            {{
              data.item.endDate
                ? $moment(data.item.endDate).format("DD/MM/YYYY")
                : "-"
            }}
          </div>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(action)="data">
          <b-button
            :disabled="checkListSelectCustomer(data.item.promocodeSerialNo)"
            class="submit-btn w-80px"
            @click.prevent="submit(data.item)"
          >
            {{
              checkListSelectCustomer(data.item.promocodeSerialNo)
                ? "เลือกแล้ว"
                : "เลือก"
            }}
          </b-button>
        </template>
      </b-table>
    </div>

    <template #modal-footer>
      <b-row>
        <b-col class="text-left">
          <b-button @click.prevent="hide(1)" class="border-btn"
            >ยกเลิก</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="showSaveBtn">
        <b-col>
          <b-button class="submit-btn" @click.prevent="submit">บันทึก</b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
export default {
  components: {},
  props: {
    hideFooter: {
      required: false,
      default: false,
      type: Boolean,
    },
    selectedCustomer: {
      required: false,
    },
    showSaveBtn: {
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
      fields: [
        {
          key: "action",
          label: "ดำเนินการ",
          class: "w-50px text-nowrap",
        },
        {
          key: "name",
          label: "ชื่อ",
        },
        {
          key: "endDate",
          label: "วันหมดอายุ",
        },
      ],
      items: [],
      isBusy: false,
      rows: 0,
      filter: {
        userId: "",
        bookingDate: "",
        eventTypeId: null,
        eventId: null,
        roundTimeEventId: null,
      },
    };
  },
  watch: {},
  methods: {
    checkListSelectCustomer(promocodeSerialNo) {
      return this.selectedCustomer?.promocodeSerialNo === promocodeSerialNo;
    },
    async show(value) {
      this.filter = {
        ...value,
      };
      this.getList();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    getList: async function () {
      this.isBusy = true;
      const respone = await this.$services.transaction.getVourcher(this.filter);
      if (respone.result === 1) {
        this.items = respone.detail.filter((item)=> item.canUse)
      }
      this.isBusy = false;
    },
    handleSearch(e) {
      this.getList();
    },

    submit(item) {
      this.$emit("select", item);
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-table {
  padding: 15px;
  .header {
    text-align: right;
    margin: 10px 0px;

    .btn-export {
      width: 100px;
      background: white;
      color: black;
    }
  }

  .footer-modal {
    text-align: right;
    margin-top: 10px;
  }
}

::v-deep .modal-dialog {
  max-width: 800px;
}

::v-deep .modal-footer {
  justify-content: space-between;
}
.btn-save {
  color: #fff;
  background-color: var(--primary-color);
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}
.btn-cancel {
  color: #fff;
  background-color: #39424e;
  width: 100%;
  border: none;
  padding: 5px 50px;
  border-radius: 0px;
}

.w-80px{
  width: 80px;
}
</style>
